import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/sections/Hero";
import { SystemIntro } from "./components/sections/SystemIntro";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Testimonials } from "./components/sections/Testimonials";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Purposes } from "./components/sections/Purposes";
import { About } from "./components/sections/About";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3mljat0fdtn5p">
      <MetaPixel data-id="element-1" data-mp="3mjq2zht18ww4" />
      <Hero data-id="element-2" data-mp="3mj6jvxrnc2gi" />
      <main data-id="element-3" data-mp="3rc9i4j7dc031">
        <SystemIntro data-id="element-4" data-mp="3rbrayrj641gc" />
        <BeforeAfter data-id="element-5" data-mp="3rdatkosaqola" />
        <PainPoints data-id="element-6" data-mp="3rd1all5o5hp3" />
        <Volumes data-id="element-7" data-mp="3relv0hy9rk98" />
        <Tools data-id="element-8" data-mp="5orh0l86u6j" />
        <Bonuses data-id="element-9" data-mp="67yvnd9206b" />
        <Testimonials data-id="element-10" data-mp="4n5i12o8na1" />
        <Offer data-id="element-11" data-mp="56qjqnmbrsa" />
        <Guarantee data-id="element-12" data-mp="7stfczkdj46" />
        <Purposes data-id="element-13" data-mp="2zld4hgdhhrep" />
        <About data-id="element-14" data-mp="2zlv32jnmchps" />
        <Faq data-id="element-15" data-mp="2zmemy5wtxg6g" />
        <FinalCta data-id="element-16" data-mp="2zmwit1fkxsdu" />
      </main>
      <Footer data-id="element-17" data-mp="33mowttnqsqql" />
      <FloatingCta data-id="element-18" data-mp="33m5a7zn5de68" />
      <PurchasePopup data-id="element-19" data-mp="33nq4do5juv3k" />
    </div>;
}